import {IStateStore}                        from '../../ap-interface';
import {Injectable}                         from '@angular/core';
import {Store}                              from '../index';
import {NetTypes, UploadSend, UploadVerify} from 'invoker-transport';
import {UploadLogVerify}                    from '../../../../projects/invoker-transport/src/lib/actions/import';
import {ApSignalrService}                   from '../../ap-core/services/ap-signalr.service';
import IGuid = System.IGuid;

interface IUploadStore extends IStateStore<any> {
  guid: IGuid;
}

@Injectable({providedIn: 'root'})
export class UploadStore extends Store<IUploadStore> {
  constructor(public backend: ApSignalrService) {
    super(backend, {
      data: [],
      loaded: false,
      loading: false,
      guid: ''
    });

    backend.registerObservable(UploadSend).subscribe(d => {
      super.Mutate(s => s.guid, () => d.Data);
    });
  }

  /**
   *  send upload data to the database
   */
  public sendUpload(fileGuid: IGuid, chunk: ArrayBuffer): void {
    super.Mutate(s => s.guid, () => '');
    const tmp = [];
    const arr = new Uint8Array(chunk);
    for (const key in arr) {
      if (!arr.hasOwnProperty(key)) {
        continue;
      }
      tmp[key] = arr[key];
    }

    this.DispatchBackend(new UploadSend([
      {Name: 'fileGuid', Type: NetTypes.GUID, Value: fileGuid},
      {Name: 'chunk', Type: NetTypes.BYTE + '[]', Value: tmp}
    ]));
  }

  /**
   *  send verify to the database
   */
  public verifyUpload(fileGuid: IGuid, filename: string, sha256Hash: string, farmId: number, userId: number, typeId: number): void {
    this.DispatchBackend(new UploadVerify([
      {Name: 'fileGuid', Type: NetTypes.GUID, Value: fileGuid},
      {Name: 'filename', Type: NetTypes.STRING, Value: filename},
      {Name: 'sha256Hash', Type: NetTypes.STRING, Value: sha256Hash},
      {Name: 'typeId', Type: NetTypes.INT, Value: typeId}
    ]));
  }

  public verifyLogUpload(fileGuid: IGuid, filename: string): void {
    this.DispatchBackend(new UploadLogVerify([
      {Name: 'fileGuid', Type: NetTypes.GUID, Value: fileGuid},
      {Name: 'filename', Type: NetTypes.STRING, Value: filename},
    ]));
  }
}
